import React from 'react';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import s from './BaseTierUpsell.scss';
export var BaseTierUpsell = function (_a) {
    var imageSrc = _a.imageSrc, imageWidth = _a.imageWidth, title = _a.title, subtitle = _a.subtitle, href = _a.href, buttonText = _a.buttonText, className = _a.className, biData = _a.biData, onClick = _a.onClick;
    return (React.createElement(Section, { className: classnames(s['root'], className) },
        imageSrc && imageWidth && (React.createElement("img", { src: imageSrc, alt: "", width: imageWidth })),
        title && React.createElement(Heading, { className: s['title'] }, title),
        subtitle && React.createElement("p", { className: s['subtitle'] }, subtitle),
        (href || onClick) && buttonText && (React.createElement(GhostButton, { className: s['button'], size: "medium", variant: "main", href: href, onClick: onClick, biData: biData }, buttonText))));
};
BaseTierUpsell.displayName = 'BaseTierUpsell';
export default BaseTierUpsell;
//# sourceMappingURL=BaseTierUpsell.js.map